import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname,hash } = useLocation();

  useEffect(() => {
    // 1. Standart pencereyi yukarı çek 
    if (!hash) {
    window.scrollTo(0, 0);

    // 2. Senin CSS yapındaki div'leri bul ve yukarı çek
    const containers = [
      document.documentElement,
      document.body,
      document.querySelector(".app-layout"),
      document.querySelector(".page-content")
    ];

    containers.forEach(el => {
      if (el) {
        el.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth" // Kayarak çıkması için
        });
      }
    });
  }
  }, [pathname]);

  return null;
}